export default __webpack_public_path__ + "static/AppFace1-81cb65a15c2f0de0c3371b5ddb973267.png";